import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://arthurfitz.com';
const DEFAULT_IMAGE = `${SITE_URL}/og-cover.jpg`;

/**
 * SEO meta component. Injects title/description/canonical/OG/Twitter tags
 * plus optional JSON-LD structured data for the current page.
 *
 * Props:
 * - title: page title (will be suffixed with " | Arthur Fitz")
 * - description: short meta description
 * - path: canonical path (e.g. "/productos" or "/producto/123")
 * - image: absolute URL to preview image (optional, defaults to og-cover)
 * - jsonLd: optional schema.org structured data object (JSON serializable)
 */
export default function Seo({ title, description, path = '', image = DEFAULT_IMAGE, jsonLd = null }) {
  const fullTitle = title ? `${title} | Arthur Fitz` : 'Arthur Fitz - Sistemas de Integración Capilar';
  const url = `${SITE_URL}${path}`;
  const desc = description || 'Prótesis capilares a medida y productos profesionales de mantenimiento capilar. Envío a toda España.';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Arthur Fitz" />
      <meta property="og:locale" content="es_ES" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
